import './RICMS.scss'
import React, { useContext, useState, useReducer } from 'react'
import PageLoader from 'components/PageLoader';
import { GlobalContext } from 'globalContext'
import { Segment, Header, Icon } from 'semantic-ui-react';
import RelatoriosForm from './RelatoriosForm';
import RelatoriosExibicao from './RelatoriosExibicao';
import PageHeader from 'components/PageHeader';

function reducer(state, action) {
    switch(action.type) {
        case 'setForm':
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export default function RICMS() {
    const [globalState] = useContext(GlobalContext)
    const [registros, setRegistros] = useState([])
    const [form, dispatch] = useReducer(reducer, {
        empresa: '',
        dataIni: '',
        dataFim: ''
    })

    function clearState() {
        setRegistros([])
        dispatch({ type: 'setForm', payload: { empresa: '', dataIni: '', dataFim: '' } })
    }

    const relatoriosFormProps = { empresas: globalState.empresas ? globalState.empresas.filter(x => x.estado === 'MG') : [], form, dispatch, setRegistros }
    const relatoriosExibicaoProps = { empresa: globalState.empresas ? globalState.empresas.find(x => x && x._id === form.empresa) : null, form, registros, setRegistros, clearState }

    return (
        <PageLoader active={!(!!globalState.empresas)}>
            <div id="ricms" className='page-content'>

                <PageHeader />

                {!registros.length && <Segment className='subcontent' >
                    <div className="row flex-grow-1">
                        <div className='col d-flex flex-column flex-grow-1'>
                            <Header as='h3'>
                                <Icon.Group size='big'>
                                    <Icon name='clipboard list' className='primary-color' />
                                </Icon.Group>
                                <Header.Content className='primary-color'>
                                    Relatório
                                    <Header.Subheader className='secondary-color'><strong>Obrigações acessórias - Definitividade da base de cálculo</strong></Header.Subheader>
                                </Header.Content>
                            </Header>
                            <div className='d-flex flex-column flex-grow-1 align-items-center justify-content-center'>
                                <RelatoriosForm {...relatoriosFormProps} />
                            </div>
                        </div>
                    </div>
                </Segment>}
                {registros.length > 0 && <Segment className='subcontent'>
                    <div className="row flex-grow-1">
                        <div className="d-print-inline-block col d-flex flex-column align-items-center">   
                            <RelatoriosExibicao {...relatoriosExibicaoProps} /> 
                        </div>
                    </div>                                       
                </Segment>}
            </div>
        </PageLoader>
    )
}   
